import React, { useState, useEffect } from 'react'
import {
  Modal,
  Button,
  Form,
  FormGroup,
  FormLabel,
  FormSelect,
} from 'react-bootstrap'
import toast from 'react-hot-toast'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useAuth } from './AuthContext'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'

const EditAssignClass = ({ show, handleClose, assignData, onUpdate }) => {
  const { user } = useAuth()
  const [updatedAssignClass, setUpdatedAssignClass] = useState({
    class_id: '',
    teacher_id: '',
  })
  console.log('ASSING DATA: ', assignData)
  const [classes, setClasses] = useState([])
  const [teachers, setTeachers] = useState([])

  const institueId = Cookies.get('institute_id')
  console.log('INSTITUTE ID:', institueId)
  const userCookie = Cookies.get('user')
  console.log('USERCOOKIE:', userCookie)

  useEffect(() => {
    if (assignData) {
      setUpdatedAssignClass({
        class_id: assignData.class_id || '',
        teacher_id: assignData.teacher_id || '',
      })
    }
  }, [assignData])

  let token = null
  console.log('TOKEN', token)

  if (userCookie) {
    try {
      const user = JSON.parse(userCookie)
      token = user.token
      console.log('TOKEN LAST:', token)
    } catch (err) {
      console.error('Failed to parse user cookie', err)
    }
  }

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${user.token}`,
    institute_id: Number(institueId),
  }

  // Fetch all classes
  useEffect(() => {
    const userCookie = Cookies.get('user')
    let token = null
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        // token = user.token
        if (user.user_type === 'teacher') return
      } catch (error) {
        console.error('Failed to parse user cookie', error)
      }
    }
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/class/all',
          { headers },
        )
        setClasses(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to fetch classes')
      }
    }
    fetchClasses()
  }, [])

  // Fetch all teachers
  useEffect(() => {
    const userCookie = Cookies.get('user')
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
        console.log('My user is :', user.user_type)
        if (user.user_type === 'teacher') return
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchTeachers = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/teacher/all',
          { headers },
        )
        setTeachers(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to fetch teachers')
      }
    }
    fetchTeachers()
  }, [])

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedAssignClass((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSaveChanges = async (e) => {
    e.preventDefault()
    console.log('Submitting Edit:')
    console.log('assignData:', assignData)
    console.log('updatedAssignClass:', updatedAssignClass)
    try {
      const response = await axios.put(
        BASE_URL+`/update-assignment/${assignData?.id}`,
        // assignData.id,
        updatedAssignClass,
        { headers },
      )
      console.log('API response:', response.data)

      // const updatedRow = {
      //   id: assignData.id, // preserve original assignment ID
      //   teacher_id: assignData.teacher_id,
      //   class_id: updatedAssignClass.class_id,
      //   class_name:
      //     classes.find((c) => c.id === updatedAssignClass.class_id)
      //       ?.class_name || '',
      // }
      // console.log('Constructed updatedRow:', updatedRow)

      // onUpdate(updatedRow)

      toast.success(response.data.message || 'Class updated successfully')

      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.message || 'Update failed')
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Assigned Class</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSaveChanges}>
          <Form.Group className="mb-3">
            <Form.Label>Class</Form.Label>
            <Form.Select
              name="class_id"
              value={updatedAssignClass.class_id}
              onChange={handleInputChange}
            >
              <option value="">Select Class</option>
              {classes.map((clas) => (
                <option key={clas.id} value={clas.id}>
                  {clas.class_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <FormGroup className="mb-3">
            <FormLabel>Teacher</FormLabel>
            <FormSelect
              name="teacher_id"
              value={updatedAssignClass.teacher_id}
              onChange={handleInputChange}
            >
              <option value="">Select Teacher</option>
              {teachers.map((teacher) => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.name}
                </option>
              ))}
            </FormSelect>
          </FormGroup>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="warning" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default EditAssignClass
